<mat-toolbar class="bar-filler"></mat-toolbar>
<div>
    <div class="fill-parent-width">
        <div class="horizontal-center">
            <div class="label center-text small-margin small-padding">{{itemGroup.Description}}</div>
        </div>
    </div>
    <div>
        <div *ngFor="let item of itens">
            <div class="disable-select">
                <div class="flex-container-center list-cell" mat-ripple (click)="itemTap(item)">
                    <img src="{{item.Picture}}" class="thumbnail block" onerror="this.src='assets/img/placeholder.png'">
                    <div class="small-padding block">
                        <div class="list-cell-label">{{item.Name}}</div>
                        <div class="list-cell-detail">{{item.Description}}</div>
                    </div>
                    <div class="block float-right small-margin small-padding">
                        <div class="striked-price-label">{{item.OriginalPriceString}}</div>
                        <div class="price-label">{{item.PriceString}}</div>
                    </div>
                </div>
                <mat-divider></mat-divider>
            </div>
        </div>
    </div>
</div>
<mat-toolbar class="bar-filler"></mat-toolbar>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{itemGroup.Name}}</div>
</mat-toolbar>
<mat-toolbar matRipple #bottomBar id="bottomBar" color="primary" class="bottom-bar">
    <mat-toolbar-row>
        <div class="big-price-text">{{currentPriceString}}</div>
    </mat-toolbar-row>
</mat-toolbar>
